{
  "title": "Модерація",
  "description": "Скарги на повідомлення та рішення щодо них.",
  "loading": "Завантаження…",
  "empty": "У цьому фільтрі скарг немає.",
  "filters": {
    "status": "Статус",
    "reason": "Причина",
    "all": "Усі"
  },
  "status": {
    "open": "Відкрита",
    "reviewed": "Розглянута",
    "dismissed": "Відхилена"
  },
  "reason": {
    "abuse": "Цькування або образи",
    "inappropriate": "Недоречний вміст",
    "spam": "Спам",
    "other": "Інше"
  },
  "row": {
    "reportedBy": "Автор скарги: {{name}}",
    "author": "Автор повідомлення: {{name}}",
    "thread": "Розмова",
    "openThread": "Відкрити розмову",
    "details": "Пояснення від автора скарги",
    "removedMessage": "Це повідомлення вилучено.",
    "reviewedBy": "Розглянуто: {{name}}",
    "resolutionNote": "Нотатка модератора"
  },
  "actions": {
    "dismiss": "Відхилити",
    "remove_message": "Вилучити повідомлення",
    "mute_participant": "Обмежити автора"
  },
  "confirm": {
    "title": "Рішення щодо скарги",
    "dismiss": "З повідомленням та його автором нічого не станеться. Скаргу буде закрито як відхилену.",
    "remove_message": "Текст повідомлення зникне для всіх; на його місці лишиться позначка «Це повідомлення вилучено». Відновити його не можна.",
    "mute_participant": "Автор і далі читатиме цю розмову, але більше не зможе в ній писати.",
    "note": "Нотатка для протоколу (необов'язково)",
    "notePlaceholder": "Чому ви так вирішили…",
    "submit": "Підтвердити",
    "submitting": "Виконуємо…",
    "cancel": "Скасувати"
  },
  "toasts": {
    "reviewed": "Скаргу розглянуто."
  },
  "queueCard": {
    "title": "Відкриті скарги",
    "empty": "Черга порожня.",
    "count_one": "{{count}} скарга чекає",
    "count_few": "{{count}} скарги чекають",
    "count_many": "{{count}} скарг чекають",
    "open": "Відкрити модерацію"
  }
}
